import styled from 'styled-components';

export const Button = styled.button`
      padding: 7px 20px;
    border-radius: 10px;
      background-color: transparent;
    color: white;
    border: 1px solid white;
    cursor: pointer;
   transition: 0.3s ease-in-out;
         transform: scale(1);

    &:hover { 
      background: white;
    color: black;
    }
  `


